module.exports = __webpack_public_path__ + "pc/img/about-global-pic03.4b71d49d.png";